export const AVATAR_COLORS = [
  'orange',
  'chocolate',
  'blueViolet',
  'cornflowerblue',
];

export const AVATAR_SCALE = 3;
